import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-9744">
      <PaymentForm data-id="element-9745" />
    </div>;
}